import { createSelector } from 'reselect';
import { pathSatisfies, sort } from 'ramda';
import { getUserId } from '../../system/selectors';
import { hasEhrId } from '../shared/person-selectors';
import { sorterByCheckedInTime } from '../shared/utils';
export const selectRealtime = (state) => state.realtime;
export const selectPeople = createSelector(selectRealtime, (realtime) => realtime.people);
export const selectForceRemoved = createSelector(selectRealtime, (realtime) => realtime.forceRemovedUUIDs);
export const selectPatients = createSelector([selectRealtime, selectForceRemoved], (realtime, forceRemoved) => sort(sorterByCheckedInTime, realtime.patients.filter((patient) => !forceRemoved.includes(patient.uuid))));
/**
 * @issue     https://doxyme.atlassian.net/browse/CS-1789
 * @todo      Fix after migration call to redux
 *   this.mapStateToThis = state => ({
        patientsInQueue: selectPatients(state).filter((patient) => {
          // TODO: Move to Redux selectPatientsInQueue
          return !VideoProviderFactory.activeProvider.peopleCollection.findByUid(patient.uuid);
        })
      });
 *
 */
export const selectPatientsInQueue = createSelector([selectPatients, getUserId], (patients, userId) => patients.filter(pathSatisfies((callInitiator) => callInitiator !== userId, ['state', 'callInitiator'])));
export const selectDoctors = createSelector(selectRealtime, (realtime) => realtime.doctors);
/**
 *
 * @param uuid String
 * @example const person = selectPersonFactory('my-uuid')(getState())
 */
export const selectPatientFactory = (uuid) => createSelector(selectPatients, (people) => people.find((person) => person.uuid === uuid));
export const selectHasEhrId = (uuid) => createSelector(selectPatientFactory(uuid), hasEhrId);
